import { createSlice } from "@reduxjs/toolkit";
import { logout } from "../auth/authSlice";

// import { getCreatorCampaignsCall } from "../../Common/Repository";
import { getCreatorCampaignsCall } from "actions/creatorAction";

const initialState = {
  loading: false,
  creatorCampaignData: [],
  creatorCampaignsCurrentPage: 1,
  creatorCampaignsTotalPages: 0,
  error: null,
  success: false,
};

const campaignsSlice = createSlice({
  name: "campaigns",
  initialState,
  reducers: {
    setCampaigns: (state, action) => {
      state.creatorCampaignData = action.payload;
    },
    setCreatorsCampaignsCurrentPage: (state, action) => {
      state.creatorCampaignsCurrentPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(logout, (state) => {
        state.creatorCampaignData = [];
      })
      .addCase(getCreatorCampaignsCall.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCreatorCampaignsCall.fulfilled, (state, action) => {
        // old logic
        state.creatorCampaignData = action.payload?.data?.data?.data;
        state.creatorCampaignsCurrentPage = action.payload?.data?.data?.current_page;
        state.creatorCampaignsTotalPages = action.payload?.data?.data?.last_page;
        // // new logic to working for branch main
        // state.creatorCampaignData = action.payload?.data?.data;
        
        state.loading = false;
        state.error = null;
      })
      .addCase(getCreatorCampaignsCall.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setCampaigns, setCreatorsCampaignsCurrentPage } = campaignsSlice.actions;
export default campaignsSlice.reducer;
